import {
  getAvailableTimeSlotsGroupReq,
  bookTimeSlotReq,
} from "@/api/services/user-bookings";
import { bookSlotStore } from "../store";
import { AxiosError } from "axios";

export const useBookSlot = () => {
  const getAvailableTimeSlotsGroup = async (
    id: string,
    month: string,
    year: string
  ) => {
    bookSlotStore.getState().setLoading(true);
    try {
      const response = await getAvailableTimeSlotsGroupReq(id, month, year);
      if (response.status === 200 && response.data) {
        bookSlotStore.getState().setTimeSlotGroup(response.data);
      } else {
        bookSlotStore.getState().setError("Error fetching time slot group");
      }
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        bookSlotStore
          .getState()
          .setError(
            error.response?.data?.message || "Error fetching time slot group"
          );
      } else {
        bookSlotStore.getState().setError("Error fetching time slot group");
      }
    } finally {
      bookSlotStore.getState().setLoading(false);
    }
  };

  const bookTimeSlot = async (slotIds: number[]) => {
    bookSlotStore.getState().setBooking(true);
    bookSlotStore.getState().clearMessages();
    try {
      const response = await bookTimeSlotReq({ slots: slotIds });
      if (response.status === 200 || response.status === 201) {
        // Clear selections and show success message
        bookSlotStore.getState().clearSelectedDate();
        bookSlotStore.getState().clearSelectedTimeSlotId();
        bookSlotStore
          .getState()
          .setSuccess("Your time slot has been successfully booked!");
        return { success: true };
      } else {
        bookSlotStore.getState().setError("Error booking time slot");
        return { success: false };
      }
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        bookSlotStore
          .getState()
          .setError(error.response?.data?.message || "Error booking time slot");
      } else {
        bookSlotStore.getState().setError("Error booking time slot");
      }
      return { success: false };
    } finally {
      bookSlotStore.getState().setBooking(false);
    }
  };

  const refreshAvailableTimeSlotsGroup = async (id: string) => {
    // Fetch available time slots for current month
    const currentDate = new Date();
    const month = (currentDate.getMonth() + 1).toString();
    const year = currentDate.getFullYear().toString();

    await getAvailableTimeSlotsGroup(id, month, year);
  };

  return {
    getAvailableTimeSlotsGroup,
    bookTimeSlot,
    refreshAvailableTimeSlotsGroup,
  };
};
